import { Button, Card, Typography } from "antd";
import "./index.css";
import { Hinid, Checked, UnChecked, English } from "../../../../Assets/icons"
import { useTranslation } from "react-i18next";
import "./../../../LanguageSelectComponent/index.css"

export default function ConsentSteps() {
  const { t } = useTranslation();
    
  return (
    <div className="languageSelectRoot">
      <img src="/ic_splash.png" alt="INK Logo" className="ink-logo" />
      <div className="row languagerow contentContainer">
        <Typography.Text className="fontWeight600 font24">
          {t("Consents")}
        </Typography.Text>
        <Typography.Text className="font24 marginLeft8">
          {t("lblapproveconsent")}
        </Typography.Text>
      </div>

      <Button
        className={`unSelectedButton row  alignCenter spaceBetween selectLanguage`}
      >
        <div className="row alignCenter">
          <div className="stepNumber">1</div>
          <div className="col justifyCenter alignStart marginleft10">
            <Typography.Text className={`unSelectedText font20 fontWeight600`}>
              {t("lblConsentreqRaised")}
            </Typography.Text>
            <Typography.Text className={`unSelectedText font10 fontWeight600`}>
              {t("lblConsentreqinitiated")}
            </Typography.Text>
          </div>
        </div>
        <Checked />
      </Button>

      <Button
        className={`selectedButton row  alignCenter spaceBetween selectLanguage`}
      >
        <div className="row alignCenter">
          <div className="stepNumber">2</div>
          <div className="col justifyCenter alignStart marginleft10">
            <Typography.Text className={`selectedText font20 fontWeight600`}>
              {t("lblEnterOTP")}
            </Typography.Text>
            <Typography.Text className={`selectedText font10 fontWeight600`}>
              {t("lblVerifyMobileNumber")}
            </Typography.Text>
          </div>
        </div>
        <Checked />
      </Button>

      <Button
        className={`unSelectedButton row  alignCenter spaceBetween selectLanguage marginBottom100`}
      >
        <div className="row alignCenter">
          <div className="stepNumber">3</div>
          <div className="col justifyCenter alignStart marginleft10">
            <Typography.Text className={`unSelectedText font20 fontWeight600`}>
              {t("lblApproveConsent")}
            </Typography.Text>
            <Typography.Text className={`unSelectedText font10 fontWeight600`}>
              {t("lblFinalApprovalPending")}
            </Typography.Text>
          </div>
        </div>
        <UnChecked />
      </Button>
  </div>


  );
}
